<template>
  <div class="stores-container">
    <div
      v-for="store in filteredStores"
      :key="store.storeId"
      class="store-section"
    >
      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="'collapse-' + store.storeId"
            block
            variant="light"
          >
            {{ getStoreName(store.storeId) }}
          </b-button>
        </b-card-header>

        <b-collapse
          :id="'collapse-' + store.storeId"
          visible
          accordion="stores-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <!-- Alerta de checkout por loja -->
            <b-alert
              v-if="shouldShowCheckoutAlert(store.storeId)"
              show
              variant="warning"
              class="text-center mb-3"
            >
              <p>
                <span class="fas fa-exclamation-triangle mr-1" />
                {{ getCheckoutAlertMessage(store.storeId) }}
              </p>
              <b-button
                v-if="isAdmin"
                size="sm"
                variant="warning"
                :to="{ name: 'CheckoutsIndex' }"
              >
                Abrir Caixa
              </b-button>
            </b-alert>

            <!-- Itens da loja -->
            <template v-if="canShowStoreItems(store.storeId)">
              <!-- Brinquedos -->
              <div
                v-if="
                  toysByStore[store.storeId] &&
                  toysByStore[store.storeId].length
                "
                class="toys-grid mb-3"
              >
                <ToyRentListItem
                  v-for="toy in toysByStore[store.storeId]"
                  :key="'toy__' + toy.id"
                  :toy="toy"
                  :disabled="!hasOpenCheckout(store.storeId)"
                  :selection-mode-active="selectionModeActive"
                  :checkouts-by-store="checkoutsByStore"
                  :store-periods="getStorePeriods(store.storeId)"
                  :loyalty-discount-enabled="
                    Boolean(toy.rent && loyaltyDiscounts[toy.rent.id])
                  "
                  @update-store-id="$emit('update-store-id', store.storeId)"
                  @trigger-action="$emit('trigger-action', $event)"
                  @update-loyalty-discount="
                    $emit('update-loyalty-discount', $event)
                  "
                  @activate-selection-mode="
                    $emit('activate-selection-mode', $event)
                  "
                  @new-rental="$emit('new-rental', $event)"
                  @reload="$emit('reload')"
                  @emitPaymentAmountsForMultiFormatPayments="
                    $emit('emitPaymentAmountsForMultiFormatPayments', $event)
                  "
                />
              </div>

              <!-- Produtos -->
              <div
                v-if="
                  productsByStore[store.storeId] &&
                  productsByStore[store.storeId].length
                "
                class="toys-grid"
              >
                <ProductListItem
                  v-for="product in productsByStore[store.storeId]"
                  :key="'product__' + product.id"
                  :product="product"
                  :disabled="!hasOpenCheckout(store.storeId)"
                  @trigger-action="$emit('trigger-action', $event)"
                />
              </div>
            </template>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import ToyRentListItem from '../../ToyRentListItem.vue'
import ProductListItem from '../../ProductListItem.vue'

export default {
  name: 'MultiStoreBoard',
  components: { ToyRentListItem, ProductListItem },
  props: {
    filteredStores: { type: Array, required: true },

    toysByStore: { type: Object, required: true },
    productsByStore: { type: Object, required: true },

    selectionModeActive: { type: Boolean, default: false },
    checkoutsByStore: { type: Object, required: true },

    // Funções vindas do pai
    hasOpenCheckout: { type: Function, required: true },
    canShowStoreItems: { type: Function, required: true },
    shouldShowCheckoutAlert: { type: Function, required: true },
    getCheckoutAlertMessage: { type: Function, required: true },
    getStoreName: { type: Function, required: true },
    getStorePeriods: { type: Function, required: true },
    loyaltyDiscounts: { type: Object, default: () => ({}) },

    isAdmin: { type: Boolean, default: false }
  },
  emits: [
    'update-store-id',
    'trigger-action',
    'update-loyalty-discount',
    'activate-selection-mode',
    'new-rental',
    'reload',
    'emitPaymentAmountsForMultiFormatPayments'
  ]
}
</script>

<style scoped>
.toys-grid {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}
@media (min-width: 350px) {
  .toys-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 580px) {
  .toys-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 992px) {
  .toys-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1200px) {
  .toys-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
